// Top-level collections:
export const RolesDefinitions = 'roles';
export const Signups = 'signups';
export const Users = 'users';
export const UsersPublic = 'public/users/data';

// Sub-collections:
const SignupListsCollection = [Signups, 'lists'];
const SignupRules = ['blacklist', 'whitelist'] as const;
const SignupLists = [...SignupRules, 'waitlist'] as const;
export type SignupRuleType = (typeof SignupRules)[number];
export type SignupListType = (typeof SignupLists)[number];
export const SignupList: Record<SignupListType, string> = SignupLists.reduce(
  (lists, list) => {
    lists[list] = toCollectionPath([...SignupListsCollection, list]);
    return lists;
  },
  {} as Record<SignupListType, string>,
);

function toCollectionPath(segments: string[]): string {
  return segments.join('/');
}
